module.exports = __webpack_public_path__ + "static/media/empty-property.1d072e07.svg";